<script>
  'use strict'
  import { get } from "svelte/store";
  import { _tileMap, _tilesCollections, _tilesCollectionFileName } from "../store/store";

  let tileMap = null;
  let tileMapFileName = null;

  // -------------------------------------------------
  getTileMap();
  
  // -------------------------------------------------
  function getTileMap() {
    tileMap = JSON.stringify(get(_tileMap));
    tileMapFileName = JSON.stringify(tileMapIdxToFileName(get(_tileMap), $_tilesCollectionFileName));
  }

  function tileMapIdxToFileName(tileMap, tiles) {
    let mapByFileName = []; 
    tileMap.forEach(elm => {
      mapByFileName.push(elm.map(tileIdx => tiles[tileIdx]));
    });
    return mapByFileName;
  }

  function copyMap() {
    document.querySelector('#resultmap').select();
    document.execCommand('copy');
  }

  function copyMapName() {
    document.querySelector('#resultmapName').select();
    document.execCommand('copy');
  }
</script>


<div class="map-array-options">
  <div>
    <button on:click="{copyMap}">COPY MAP BY INDEX</button>
    <textarea id="resultmap" bind:value={tileMap}></textarea>
  </div>
  <div>
    <button on:click="{copyMapName}">COPY MAP BY FILENAME</button>
    <textarea id="resultmapName" bind:value={tileMapFileName}></textarea>
  </div>
</div>


<style>
  textarea {
    width: 100%;
    height: 50vh;
    margin-top: 24px;
    background-color: rgba(255, 255, 255, 0.6);
  }

  .map-array-options {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
</style>